import UAParser from 'ua-parser-js';

async function getDeviceInfo() {
    const parser = new UAParser();
    const result = parser.getResult();
    return {
        browser: result.browser.name || 'Unknown',
        os: result.os.name || 'Unknown',
        device: result.device.type || 'desktop',
    };
}

export default getDeviceInfo;
